export default "__VITE_ASSET__DLXww86Q__"